module.exports = __webpack_public_path__ + "img/Result_Best_0608_01_2.d9d3560d.png";